import { Locale, type LocalizedString } from "./Locale.js";

export enum NewsCategory {
	News = "News",
	Guides = "Guides",
	ProductNews = "ProductNews",
	Events = "Events",
}

export const newsCategoryNameMap: Record<NewsCategory, LocalizedString> = {
	[NewsCategory.News]: {
		[Locale.cs]: "Aktuality",
		[Locale.en]: "News",
	},
	[NewsCategory.Guides]: {
		[Locale.cs]: "Návody & tipy",
		[Locale.en]: "Guides & tips",
	},
	[NewsCategory.ProductNews]: {
		[Locale.cs]: "Produktové novinky",
		[Locale.en]: "Product news",
	},
	[NewsCategory.Events]: {
		[Locale.cs]: "Akce & veletrhy",
		[Locale.en]: "Events & trade shows",
	},
};
